<template>
    <div class="DshTable">
        <ev-table
            :data="data"
            :columnsList="selfColumns"
            :showSort="propsObj.showSort"
            :tableBgColor="propsObj.tableBgColor"
            :title-bg-color="propsObj.titleBgColor"
            :odd-bg-color="propsObj.oddBgColor"
            :even-bg-color="propsObj.evenBgColor"
            :row-hover-color="propsObj.rowHoverColor"
            :row-click-color="propsObj.rowClickColor"
            :noDataText="propsObj.noDataText"
            :selectChange="changeSelect"
            :selectAll="changeSelect"
            @click-row="clickRow"
            @sort-change="changeSort"
        ></ev-table>
    </div>
</template>

<script>
    export default {
        name: "DshTable",
        props: {
            data: {
                type: Array,
                default () {
                    return [];
                }
            },
            columns: {
                type: Array,
                default () {
                    return [];
                }
            },
            ownColumns: Array,
            propsObj: {
                type: Object,
                default () {
                    return {};
                }
            },
            operationList: {
                type: Array,
                default () {
                    return [];
                }
            }
        },
        data () {
            return {};
        },
        computed: {
            selfOperationList () {
                const getOperationItemMaxWidth = (operationItem) => {
                    // 字宽
                    return Math.max(
                        ...(operationItem._name_ || operationItem.name).split("/").map(item => item.length * (operationItem.size === "small" ? 12 : 14))
                    ) +
                    // 按钮的padding,故意多了2px保留余地
                    (operationItem.size === "small" ? 16 : 32);
                };

                return this.operationList.map(operationItem => {
                    return {
                        ...operationItem,
                        width: operationItem.width
                            ? operationItem.width
                            : (getOperationItemMaxWidth(operationItem)),
                        style: (operationItem._name_ || operationItem.name).split("/").length > 1
                            ? `width: ${getOperationItemMaxWidth(operationItem)}px; `
                            : undefined
                    };
                });
            },
            selfColumns () {
                if (this.ownColumns) {
                    return this.ownColumns;
                }
                return [
                    {
                        title: "多选",
                        _name: "多选",
                        type: "selection",
                        width: 45,
                        titleAlign: "left",
                        columnAlign: "left",
                        isFrozen: true
                    },
                    {
                        field: "custome",
                        title: "序号",
                        _name: "序号",
                        width: 67,
                        titleAlign: "left",
                        columnAlign: "left",
                        isFrozen: true,
                        formatter: function (rowData, rowIndex, pagingIndex, field) {
                            return rowIndex + 1;
                        }
                    }
                ].concat(
                    this.columns,
                    {
                        title: "操作",
                        _name: "操作",
                        type: "expend",
                        width: Math.max(
                            // 漏在外部按钮的宽度
                            this.selfOperationList.slice(0, this.selfOperationList.length > 2 ? 1 : 2).reduce((total, operationItem, operationIndex) => {
                                return total + operationItem.width + (operationIndex ? 6 : 0);
                            }, 0) +
                                // 出现更多按钮的宽度
                                (this.selfOperationList.length > 2 ? (81 + 5) : 0) +
                                // 操作列的padding
                                (this.selfOperationList.length > 0 ? 30 : 0),
                            80),
                        titleAlign: "center",
                        columnAlign: "center",
                        componentName: "dsh-td-render",
                        isFrozenRight: true,
                        render: (h, params) => {
                            const totalOperationList = this.selfOperationList.map(operationItem => {
                                return {
                                    ...operationItem,
                                    ...(operationItem.operationFunc
                                        ? operationItem.operationFunc(operationItem, params.row, params.index)
                                        : {}
                                   )
                                };
                            });
                            const outFilterOperationList = totalOperationList.slice(0, 1);
                            const moreFilterOperationList = totalOperationList.slice(1).filter(operationItem => !operationItem.disabled);

                            // TODO: 注意此处totalOperationList用的一定是表格行显示最多的操作按钮数组，有改动注意看此备注！！！
                            return totalOperationList.length < 3
                                ? h("dsh-buttons", {
                                    props: {
                                        list: totalOperationList
                                    },
                                    on: {
                                        click: (operationItem) => {
                                            this.$dshEmit(operationItem, params.row, params.row);
                                        }
                                    }
                                })
                                : h("div", [
                                    h("dsh-buttons", {
                                        style: {
                                            display: "inline-block"
                                        },
                                        props: {
                                            list: outFilterOperationList
                                        },
                                        on: {
                                            click: (operationItem) => {
                                                this.$dshEmit(operationItem, params.row, params.row);
                                            }
                                        },
                                        nativeOn: {
                                            click: (e) => {
                                                e.stopPropagation();
                                            }
                                        }
                                    }),
                                    h("dsh-dropdown", {
                                        props: {
                                            dropdownObj: {
                                                icon: "ios-more",
                                                size: 22,
                                                color: "#E9ECF4",
                                                showDropdownItemIcon: false
                                            },
                                            list: moreFilterOperationList
                                        },
                                        on: {
                                            click: (operationItem) => {
                                                this.$dshEmit(operationItem, params.row, params.row);
                                            }
                                        },
                                        nativeOn: {
                                            click: (e) => {
                                                e.stopPropagation();
                                            }
                                        }
                                    }, [
                                        h("dsh-buttons", {
                                            class: "dsh-margin-left5",
                                            props: {
                                                list: [
                                                    {
                                                        name: "更多>>",
                                                        type: "more",
                                                        btnType: "text",
                                                        size: "default",
                                                        disabled: !moreFilterOperationList.length
                                                    }
                                                ]
                                            }
                                        })
                                    ])
                            ]);
                        }
                    }
                );
            }
        },
        created () {
        },
        methods: {
            // 点击某行
            clickRow (...params) {
                this.$emit("clickRow", ...params);
            },

            // 改变选择项
            changeSort (...params) {
                this.$emit("sortChange", ...params);
            },
            // 改变选择项
            changeSelect (...params) {
                this.$emit("selectChange", params[0].map(item => item._id), ...params);
            }
            // // 切换全选
            // selectAll (...params) {
            //     this.$emit("selectAll", ...params);
            // },
            // // 切换选择
            // select (...params) {
            //     this.$emit("select", ...params);
            // },
        }
    };
</script>

<style lang="less" scoped>
    .DshTable {

    }
</style>
<style lang="less">
    .DshTable {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/list/DshBox/DshTable.vue